import InvitedPage from './InvitedPage';

export default InvitedPage;
